import { render, staticRenderFns } from "./data-management-insights-card.vue?vue&type=template&id=d2a6aa74&scoped=true&"
import script from "./data-management-insights-card.vue?vue&type=script&lang=js&"
export * from "./data-management-insights-card.vue?vue&type=script&lang=js&"
import style0 from "./data-management-insights-card.vue?vue&type=style&index=0&id=d2a6aa74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a6aa74",
  null
  
)

component.options.__file = "data-management-insights-card.vue"
export default component.exports